// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"1c0eef81","392":"545e75fd","400":"00d2d0cc","544":"91366dfb","772":"324fbf63"}[chunkId] + ".chunk.js";
};